import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { useWorkOrders } from "../../../data/WorkOrdersHook";
import { useProjects } from "../../../data/ProjectsHook";
import { useWorkItemAgreements } from "../../../data/WorkItemAgreementsHook";
import "./WorkItemEntry.css";
import EngineerAvailability from "../../engineerAvailability/EngineerAvailability";

function DomesticCMVEntry() {
  const workOrdersRepository = useWorkOrders();
  const projectsRepository = useProjects();
  const workItemAgreementsRepository = useWorkItemAgreements();
  const workOrder = workOrdersRepository.getEntry();

  const updateProject = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      projectId: e.target.value,
      projectName: e.target.selectedOptions[0].text,
    };
    workOrdersRepository.setEntry(revised);
  };

  const anyTimeSlot = { id: "PATS003", title: "Any time" };

  const updateAppointment = (date, slot, agreedoutsidesla) => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      agreedoutsidesla,
      preferredAppointmentDate: date,
      preferredAppointmentSlot: slot.id,
      preferredAppointmentSlotTitle: slot.title,
    };
    workOrdersRepository.setEntry(revised);
  };

  const updateAppointmentConfirmed = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      preferredAppointmentDate: "",
      preferredAppointmentSlot: anyTimeSlot.id,
      preferredAppointmentSlotTitle: anyTimeSlot.title,
      appointmentConfirmed: e.target.value,
      appointmentConfirmedTitle: e.target.selectedOptions[0].text,
    };
    workOrdersRepository.setEntry(revised);
  };

  const updateJobSpecificAccessNotes = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, jobSpecificAccessNotes: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const workItemAgreements =
    workItemAgreementsRepository.getWorkItemAgreements();
  const projects = projectsRepository.getProjects();

  const appointmentData = {
    appointmentConfirmed: workOrder.appointmentConfirmed,
    preferredAppointmentDate: workOrder.preferredAppointmentDate,
    slahours: workOrder.slahours,
    preferredAppointmentSlotTitle: workOrder.preferredAppointmentSlotTitle,
  };

  return (
    <div className="work-order-item-section">
      <h3>Domestic CMV Work Item Details</h3>
      <Container className="work-order-item-container">
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="projectGroup">
              <Form.Label>Project</Form.Label>
              <Form.Select
                value={workOrder.projectReference}
                onChange={updateProject}
              >
                {projects.map((nextSlot) => (
                  <option
                    key={nextSlot.projectReference}
                    value={nextSlot.projectReference}
                  >
                    {nextSlot.projectName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3" controlId="appointmentConfirmedGroup">
              <Form.Label>
                Will this be an agreed or not agreed appointment?
              </Form.Label>
              <Form.Select
                value={workOrder.appointmentConfirmed}
                onChange={updateAppointmentConfirmed}
              >
                {workItemAgreements.map((nextItem) => (
                  <option key={nextItem.id} value={nextItem.id}>
                    {nextItem.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <EngineerAvailability 
              updateAppointment={updateAppointment}
              appointmentData={appointmentData}
            />

            <Form.Group className="mb-3" controlId="jobSpecificAccessNoteGroup">
              <Form.Label>Job Specific Access Notes</Form.Label>
              <Form.Control
                as="input"
                value={workOrder.jobSpecificAccessNotes}
                onChange={updateJobSpecificAccessNotes}
              />
            </Form.Group>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DomesticCMVEntry;
